const createProgram = ({
  name,
  type,
  sourceUrl,
  mapQuery,
  overview,
  credential,
  format,
  length,
  tuition,
  admissions,
  focus,
  highlights,
}) => ({
  name,
  type,
  credential,
  format,
  length,
  tuition,
  admissions,
  summary: overview,
  badge: type,
  websiteUrl: sourceUrl,
  sourceUrl,
  specs: [
    ['Program type', type],
    ['Credential', credential],
    ['Class format', format],
    ['Program length', length],
    ['Tuition and fees', tuition],
    ['Admissions', admissions],
  ],
  paragraphs: [
    focus,
    'Confirm current schedules, locations, tuition, admissions requirements, credentials, and licensing details directly with the school before enrolling.',
  ],
  highlights,
  address: `${name}, Connecticut`,
  mapEmbedUrl: `https://www.google.com/maps?q=${encodeURIComponent(mapQuery)}&output=embed`,
});

export const programs = [
  createProgram({
    name: 'Porter and Chester Institute',
    type: 'Private HVACR career training',
    sourceUrl: 'https://porterchester.edu/programs/hvacr/',
    mapQuery: 'Porter and Chester Institute Connecticut Bridgeport Hamden Rocky Hill Waterbury',
    overview: 'Porter and Chester Institute delivers an intensive, career-focused HVACR diploma program at locations including Bridgeport, Hamden, Rocky Hill, and Waterbury.',
    credential: 'HVACR diploma with EPA Section 608 preparation',
    format: 'Hybrid online learning with hands-on shop training',
    length: 'As few as 12 months',
    tuition: 'Approximately $29,000; confirm current tuition, tools, and fees',
    admissions: 'Contact the school for current location and admissions requirements',
    focus: 'Students train on modern residential and commercial systems while building field-ready skills in installation, maintenance, diagnostics, and repair. The program includes preparation for important industry credentials, including EPA Section 608 Universal certification.',
    highlights: [
      'Multiple Connecticut campus locations',
      'Hands-on training with residential and commercial systems',
      'EPA Section 608 Universal certification preparation',
    ],
  }),
  createProgram({
    name: 'Lincoln Technical Institute',
    type: 'Private technical career school',
    sourceUrl: 'https://www.lincolntech.edu/campus/east-windsor-ct',
    mapQuery: 'Lincoln Technical Institute East Windsor New Britain Shelton Connecticut',
    overview: 'Lincoln Technical Institute offers a Heating, Ventilation, and Air Conditioning Technology diploma program serving students in East Windsor, New Britain, and Shelton.',
    credential: 'Heating, Ventilation, and Air Conditioning Technology diploma',
    format: 'Blended classroom instruction and practical workshop training',
    length: 'Approximately 10 to 12 months',
    tuition: '$20,000-$33,000 depending on fees, tools, and materials',
    admissions: 'Review current campus-specific admissions requirements',
    focus: 'Lincoln Tech combines traditional HVAC repair skills with Green Technology and energy auditing concepts. Students learn how modern efficiency standards influence equipment selection, maintenance, and system performance.',
    highlights: [
      'East Windsor, New Britain, and Shelton locations',
      'Green Technology and energy auditing concepts',
      'Blended theory and practical workshop experience',
    ],
  }),
  createProgram({
    name: 'Industrial Management & Training Institute (IMTI)',
    type: 'Private trade training institute',
    sourceUrl: 'https://imti.edu/',
    mapQuery: 'Industrial Management and Training Institute IMTI Waterbury Connecticut',
    overview: 'Industrial Management & Training Institute provides practical HVAC trade training in Waterbury with flexible day and evening schedules.',
    credential: 'HVAC trade training aligned with state apprenticeship and technical requirements',
    format: 'Hands-on day or evening classes',
    length: '10 months during the day or 20 months in the evening',
    tuition: 'Approximately $20,000-$35,000 overall; confirm current costs',
    admissions: 'Contact IMTI for current enrollment and schedule requirements',
    focus: 'The curriculum emphasizes direct troubleshooting, electrical controls, component servicing, and practical system work. Experienced field technicians help students develop skills that align with Connecticut trade and apprenticeship expectations.',
    highlights: [
      'Flexible day and evening scheduling',
      'Waterbury-based practical trade instruction',
      'Troubleshooting, controls, and component servicing',
    ],
  }),
  createProgram({
    name: 'Entech Advanced Energy Training Center',
    type: 'Advanced energy and mechanical training',
    sourceUrl: 'https://entechtraining.com/',
    mapQuery: 'Entech Advanced Energy Training Center Cromwell Connecticut',
    overview: 'Entech Advanced Energy Training Center in Cromwell specializes in accelerated instruction for high-efficiency systems, energy auditing, and Connecticut mechanical licensing preparation.',
    credential: 'Modular and certificate training; S-2 heating, piping, and cooling preparation',
    format: 'Accelerated modular technical instruction',
    length: 'Varies by module, certificate, and licensing track',
    tuition: 'Varies by selected module or certificate package',
    admissions: 'Contact Entech for current course and licensing-track requirements',
    focus: 'Entech is suited to working adults, technicians, and aspiring contractors seeking targeted instruction rather than a lengthy general program. Training can focus on high-efficiency systems, energy auditing, and advanced mechanical knowledge.',
    highlights: [
      'Cromwell location',
      'Accelerated training for working adults',
      'S-2 and advanced energy-system preparation',
    ],
  }),
  createProgram({
    name: 'Construction Education Center',
    type: 'Construction education and apprenticeship support',
    sourceUrl: 'https://constructioneducationcenter.com/',
    mapQuery: 'Construction Education Center Connecticut',
    overview: 'The Construction Education Center provides industry-backed courses and apprenticeship support for people pursuing commercial and residential construction trades in Connecticut.',
    credential: 'Course completion or apprenticeship-related training; varies by pathway',
    format: 'Classroom instruction, continuing education, and apprenticeship support',
    length: 'Short seminars to multi-year trade blocks',
    tuition: 'Varies by trade pathway, course, or employer sponsorship agreement',
    admissions: 'Review requirements for the selected course or apprenticeship pathway',
    focus: 'The center connects classroom education with real-world construction networks. Students should compare available HVAC-related courses, employer sponsorship arrangements, apprenticeship requirements, and the practical experience included in each pathway.',
    highlights: [
      'Industry-backed construction education',
      'Apprenticeship and employer-support pathways',
      'Flexible course lengths for different trade goals',
    ],
  }),
  createProgram({
    name: 'Bristol Technical Education Center',
    type: 'Public technical education',
    sourceUrl: 'https://www.cttech.org/bristol/',
    mapQuery: 'Bristol Technical Education Center Connecticut',
    overview: 'Bristol Technical Education Center is part of Connecticut’s public technical school network and offers accessible career training for adult learners and high school upperclassmen.',
    credential: 'Technical education or adult-training credential; verify current program offerings',
    format: 'Public technical instruction with intensive shop work',
    length: 'Varies by adult or secondary program',
    tuition: 'Often substantially lower than private trade-school tuition; confirm current costs',
    admissions: 'Requirements vary for adult learners and high school students',
    focus: 'Students build practical experience in mechanical installation, shop procedures, and technical systems while preparing for regional trade careers. Public funding can make this one of the more accessible options for eligible students.',
    highlights: [
      'Public technical school network',
      'Accessible pricing for qualifying learners',
      'Strong emphasis on shop work and mechanical installation',
    ],
  }),
  createProgram({
    name: 'Connecticut Technical Education and Career System (CTECS)',
    type: 'Statewide public technical education',
    sourceUrl: 'https://www.cttech.org/',
    mapQuery: 'Connecticut Technical Education and Career System HVAC',
    overview: 'CTECS provides statewide public technical education, including adult extension programs and career pathways related to HVAC systems.',
    credential: 'Technical education and adult extension credentials; varies by campus and pathway',
    format: 'Campus-based technical education and adult extension programs',
    length: 'Varies by campus, certificate, and extension course',
    tuition: 'Typically a few thousand dollars or less depending on program and eligibility',
    admissions: 'Requirements and availability vary across the CTECS system',
    focus: 'CTECS balances foundational mechanics, electrical troubleshooting, safety, and code compliance. Its public structure can help students transition toward local mechanical unions, service companies, and other Connecticut employers.',
    highlights: [
      'Statewide public technical education network',
      'Subsidized tuition for eligible students',
      'Mechanical, electrical, and code-compliance foundations',
    ],
  }),
  createProgram({
    name: 'Henry Abbott Technical High School',
    type: 'Public technical education and adult training',
    sourceUrl: 'https://www.cttech.org/henry-abbott/',
    mapQuery: 'Henry Abbott Technical High School Danbury Connecticut',
    overview: 'Henry Abbott Technical High School serves the Danbury area with vocational programming and technical training opportunities for local students and qualifying adult learners.',
    credential: 'Technical education or adult career-upgrade credential; verify current options',
    format: 'Public technical instruction with hands-on mechanical training',
    length: 'Varies by secondary, adult, or career-upgrade pathway',
    tuition: 'Often free or nominal for qualifying participants',
    admissions: 'Eligibility varies by student status, residency, and selected program',
    focus: 'The program offers practical exposure to mechanical installation and basic system diagnostics. Adult and career-upgrade options may provide a lower-cost route for local residents seeking entry-level trade competence.',
    highlights: [
      'Danbury-area technical education',
      'Hands-on mechanical installation practice',
      'Low-cost options for qualifying local participants',
    ],
  }),
  createProgram({
    name: 'Connecticut State Community College',
    type: 'Public community college system',
    sourceUrl: 'https://ctstate.edu/',
    mapQuery: 'Connecticut State Community College industrial engineering technology HVAC',
    overview: 'Connecticut State Community College brings together regional campuses and partner programs offering affordable public education in industrial and engineering technologies.',
    credential: 'Certificates and Associate of Science degrees',
    format: 'Campus-based and online-supported academic and technical instruction',
    length: 'Approximately 1 year for certificates or 2 years for associate degrees',
    tuition: 'Approximately $4,000-$5,000 per year for in-state tuition; confirm current rates',
    admissions: 'Review current Connecticut State admissions and program requirements',
    focus: 'CT State can suit students who want a regionally accredited academic credential alongside foundational mechanical and engineering technology coursework. Compare campuses, certificates, transfer options, laboratory access, and any HVAC-related partner offerings.',
    highlights: [
      'Multiple campuses and online partner options',
      'Certificate and Associate of Science pathways',
      'Affordable in-state public college tuition',
    ],
  }),
];

export const resources = [
  {
    title: 'Connecticut Department of Consumer Protection',
    description: 'Review Connecticut trade licensing information and contractor requirements.',
    url: 'https://portal.ct.gov/dcp',
  },
  {
    title: 'U.S. Environmental Protection Agency',
    description: 'Review federal Section 608 refrigerant certification requirements.',
    url: 'https://www.epa.gov/section608',
  },
  {
    title: 'Connecticut Technical Education and Career System',
    description: 'Explore statewide public technical education and career training options.',
    url: 'https://www.cttech.org/',
  },
  {
    title: 'U.S. Bureau of Labor Statistics',
    description: 'Research HVAC mechanic and installer duties, pay, education, and employment outlook.',
    url: 'https://www.bls.gov/ooh/installation-maintenance-and-repair/heating-air-conditioning-and-refrigeration-mechanics-and-installers.htm',
  },
];